import { atom } from "recoil";
import { IBusLicensesAndPermitsDetails, SelectedRowsToDelete } from "../types";

export const busLicensesShowState = atom({
  key: "busLicensesShowState",
  default: false,
});

export const busLicensesAddState = atom({
  key: "busLicensesAddState",
  default: false,
});
export const busLicensesEditState = atom({
  key: "busLicensesEditState",
  default: false,
});

export const rowForEditBusLicense = atom<
  IBusLicensesAndPermitsDetails | undefined
>({
  key: "rowForEditBusLicense",
  default: undefined,
});

export const busLicensesSaving = atom({
  key: "busLicensesSaving",
  default: false,
});

export const setLinkStateBusLicensePermit = atom({
  key: "setLinkStateBusLicensePermit",
  default: false,
});

export const selectedRowsStateBLP = atom<SelectedRowsToDelete | undefined>({
  key: "selectedRowsStateBLP",
  default: undefined,
});

export const bLPAttachments = atom<(File | null)[]>({
  key: "bLPAttachments",
  default: [null],
});

export const bLPAttachmentsForDelete = atom({
  key: "bLPAttachmentsForDelete",
  default: [],
});

export const busLicensePermitFromOffice = atom({
  key: "busLicensePermitFromOffice",
  default: false,
});

export const busLPViewData = atom({
  key: "busLPViewData",
  default: undefined,
});

export const businessLicenseFromOffice = atom({
  key: "businessLicenseFromOffice",
  default: false,
});

export const businessLicenseOfficeId = atom<number | null>({
  key: "businessLicenseOfficeId",
  default: null,
});
export const disableBLOfficeField = atom({
  key: "disableBLOfficeField",
  default: false,
});
export const vendorToBlpId = atom({
  key: "vendorToBlpId",
  default: null,
});
export const closeFromVendorToBlp = atom({
  key: "closeFromVendorToBlp",
  default: false,
});
export const isFilterBLP = atom({
  key: "isFilterBLP",
  default: false,
});